export const feeTypeConst = [
    { label: 'Percentage of Sale', value: 'Percentage of Sale' },
    { label: 'Percentage of Lesser of Sale Price and Total Debt', value: 'Percentage of Lesser of Sale Price and Total Debt' },
    { label: 'Flat Fee', value: 'Flat Fee' },
];
export const loanTypeConst = [
    { label: 'FHA', value: 'FHA' },
    { label: 'Conventional', value: 'Conventional' },
    { label: 'USDA', value: 'USDA' },
    { label: 'VA', value: 'VA' }
  ];
export const  typeOfSaleConst = [
    { label: 'Cry', value: 'Cry' },
    { label: 'Market Only', value: 'Market Only' }
  ]